@if (value !== undefined && value !== null && value !== '') {
    <div
        (mouseleave)="isEditable ? onMouseLeave() : null"
        (mouseenter)="isEditable ? onMouseEnter() : null"
        (blur)="isEditable ? onBlur() : null"
        (focus)="isEditable ? onFocus() : null"
    >
        <div
            class="priority-cell"
            [ngClass]="{ 'not-editable': !isEditable }"
            (click)="isEditable ? onClickCell() : null"
            (keypress)="isEditable ? onKeyPress($event) : null"
            tabindex="0"
            role="button"
        >
            @if (value === 0) {
                <span class="m--margin-right-10">-</span>
            } @else {
                <svg
                    [ngStyle]="{ fill: getDataTypePriorityColor(value) }"
                    width="26"
                    height="26"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M11.6045 3.50708L6.15445 13.0571C5.94796 13.4103 5.94856 13.8476 6.15601 14.2003C6.36347 14.553 6.74538 14.7659 7.15445 14.7571H10.0145C10.3822 14.7544 10.7358 14.8986 10.9967 15.1577C11.2577 15.4168 11.4045 15.7693 11.4045 16.1371V19.7471C11.4078 20.1856 11.6966 20.5708 12.1166 20.697C12.5366 20.8233 12.9899 20.6611 13.2345 20.2971L18.5145 12.3771C18.7455 12.0286 18.7673 11.5816 18.5712 11.2123C18.3751 10.8431 17.9926 10.6108 17.5745 10.6071H14.8545C14.0923 10.6071 13.4745 9.98924 13.4745 9.22708V4.00708C13.4776 3.55169 13.1727 3.15166 12.7328 3.03403C12.2928 2.9164 11.829 3.11087 11.6045 3.50708Z"
                    />
                </svg>
                <span
                    class="m--margin-right-10"
                    [title]="title"
                    [ngStyle]="{ color: getDataTypePriorityColor(value) }"
                >
                    {{ value | formatString }}
                </span>
            }
            @if (isEditable) {
                <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M5 5C4.886 5.00049 4.7766 4.95867 4.69649 4.88398L0.115271 0.665147C-0.0424144 0.509309 -0.0377616 0.266463 0.125795 0.115844C0.289352 -0.0347745 0.553058 -0.0390592 0.722283 0.106152L5 4.04549L9.27772 0.106152C9.44694 -0.0390592 9.71065 -0.0347745 9.87421 0.115844C10.0378 0.266463 10.0424 0.509309 9.88473 0.665147L5.30351 4.88398C5.2234 4.95867 5.114 5.00049 5 5Z"
                        fill="black"
                        fill-opacity="0.25"
                    />
                </svg>
            }
        </div>
        @if (isSliderVisible) {
            <div
                class="slider form-group m-form__group m-form__group--md"
                [ngClass]="{ 'slider-top': isSliderTop }"
            >
                <div class="input-group">
                    <div class="input-group-slider">
                        <emma-slider
                            class="emma-ngx-slider-brand"
                            name="emma_slider_value_table_cell"
                            [(value)]="value"
                            (valueChange)="onPriorityChange($event)"
                            [min]="MIN_PRIORITY"
                            [max]="MAX_PRIORITY"
                            [showTicks]="true"
                            [showTicksValues]="false"
                            [hidePointerLabels]="false"
                            [tickStep]="TICK_STEP"
                            [getLegend]="priorityLegend"
                        ></emma-slider>
                    </div>
                </div>
            </div>
        }
    </div>
} @else {
    <span class="m--margin-right-10">-</span>
}
